export default [{
    name: 'dashboard',
    children: [{
        path: '/adapter/smslist',
        components: {
            default: resolve => require(['./smslist.vue'], resolve)
        }
    },{
        path:'/adapter/smsdetail',
        components:{
            default:resolve=>require(['./smsdetails.vue'],resolve)
        }
    }]
}]



// WEBPACK FOOTER //
// ./src/views/adapter/router.js